module.exports = __webpack_public_path__ + "media/images/shared/icon-onlineApprovalOrForm-be8cc0b05387c3a158e4348c578a0fb2.png";